import dynamic from "next/dynamic";

export const DynamicContent044 = dynamic(() => import("./Content044"), {
  suspense: true,
});
